(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["iro-kit-builder"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('iro-kit-builder')) {
    customElements.define('iro-kit-builder', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.form = this.querySelector('[data-kit-form]');
        if (!this.form) return;
        this.messages = JSON.parse(this.querySelector('[data-kit-messages]').textContent);
        this.bundle = new Map();
        this.busy = false;
        this.mustReview = false;
        this.activeFilter = 'all';
        this.minimum = Math.max(1, Number(this.dataset.minimum) || 2);
        this.cards = [...this.querySelectorAll('[data-kit-card]')];
        this.feedback = this.querySelector('[data-kit-feedback]');
        this.submitButton = this.querySelector('[data-kit-submit]');
        this.reviewLink = this.querySelector('[data-kit-review]');
        this.qualification = this.querySelector('[data-kit-qualification]');
        this.formatter = new Intl.NumberFormat(this.dataset.locale || document.documentElement.lang || 'en', { style: 'currency', currency: this.dataset.currency, currencyDisplay: 'symbol' });
        this.querySelectorAll('[data-kit-interactive]').forEach(element => { element.hidden = false; });
        this.cards.forEach(card => {
          const image = card.querySelector('.iro-kit__image');
          if (image) card.originalImage = { src: image.getAttribute('src'), srcset: image.getAttribute('srcset') };
          this.updateVariant(card);
        });
        this.form.addEventListener('change', event => {
          if (this.busy || this.mustReview) return;
          if (event.target.matches('[data-kit-variant]')) this.updateVariant(event.target.closest('[data-kit-card]'));
        });
        this.form.addEventListener('input', event => { if (event.target.matches('[data-kit-search]')) this.filterProducts(); });
        this.form.addEventListener('keydown', event => { if (event.key === 'Enter' && event.target.matches('[data-kit-search]')) event.preventDefault(); });
        this.form.addEventListener('click', event => {
          const filter = event.target.closest('[data-kit-filter]');
          if (filter) {
            this.activeFilter = filter.dataset.kitFilter;
            this.querySelectorAll('[data-kit-filter]').forEach(button => button.setAttribute('aria-pressed', String(button === filter)));
            this.filterProducts();
          }
          if (event.target.closest('[data-kit-reset]')) {
            this.activeFilter = 'all';
            this.querySelector('[data-kit-search]').value = '';
            this.querySelectorAll('[data-kit-filter]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.kitFilter === 'all')));
            this.filterProducts();
          }
          if (this.busy || this.mustReview) return;
          const add = event.target.closest('[data-kit-add]');
          if (add) this.addSelection(add.closest('[data-kit-card]'));
          const action = event.target.closest('[data-kit-line-action]');
          if (action) this.changeSelection(action.dataset.kitLineId, action.dataset.kitLineAction);
        });
        this.form.addEventListener('submit', event => this.addKit(event));
        this.querySelector('[data-kit-summary-link]').addEventListener('click', () => {
          if (this.mustReview) { window.location.assign(this.dataset.cartUrl); return; }
          this.querySelector('.iro-kit__summary').scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
          const heading = this.querySelector('.iro-kit__summary h2');
          heading.setAttribute('tabindex', '-1');
          heading.focus({ preventScroll: true });
        });
        this.filterProducts();
        this.updateSummary();
      }
      money(amount) { return this.formatter.format(amount / 100); }
      filterProducts() {
        const query = this.querySelector('[data-kit-search]').value.trim().toLocaleLowerCase();
        let count = 0;
        this.cards.forEach(card => {
          const shown = (this.activeFilter === 'all' || card.dataset.category === this.activeFilter) && card.dataset.title.toLocaleLowerCase().includes(query);
          card.hidden = !shown;
          if (shown) count += 1;
        });
        this.querySelector('[data-kit-results]').textContent = this.messages.results.replace('[count]', String(count));
        this.querySelector('[data-kit-no-results]').hidden = count > 0;
      }
      updateVariant(card) {
        const select = card.querySelector('[data-kit-variant]');
        if (!select) return;
        const option = select.selectedOptions[0];
        const button = card.querySelector('[data-kit-add]');
        const available = option?.dataset.available === 'true';
        button.disabled = !available || this.busy || this.mustReview;
        card.querySelector('[data-kit-add-text]').textContent = available ? this.messages.include : this.messages.soldOut;
        if (option) {
          card.querySelector('[data-kit-price]').textContent = this.money(Number(option.dataset.price));
          const image = card.querySelector('.iro-kit__image');
          if (image && card.originalImage) {
            if (option.dataset.image) { image.removeAttribute('srcset'); image.src = option.dataset.image; }
            else { image.src = card.originalImage.src; if (card.originalImage.srcset) image.setAttribute('srcset', card.originalImage.srcset); }
          }
        }
      }
      addSelection(card) {
        const select = card.querySelector('[data-kit-variant]');
        const option = select?.selectedOptions[0];
        if (!option || option.dataset.available !== 'true') return;
        const id = select.value;
        const existing = this.bundle.get(id);
        const minimum = Math.max(1, Number(option.dataset.min) || 1);
        const increment = Math.max(1, Number(option.dataset.step) || 1);
        const maximum = option.dataset.max ? Number(option.dataset.max) : Infinity;
        const quantity = existing ? existing.quantity + increment : minimum;
        if (quantity > maximum) { this.showFeedback(this.messages.maxQuantity, true); return; }
        this.bundle.set(id, { id, card, title: card.dataset.title, variant: option.textContent.trim(), price: Number(option.dataset.price), quantity, minimum, increment, maximum, restricted: card.dataset.restricted === 'true', image: card.querySelector('.iro-kit__image')?.src || '' });
        this.showFeedback('');
        this.announce(this.messages.selectionAdded.replace('[product]', card.dataset.title));
        this.updateSummary();
      }
      changeSelection(id, action) {
        const item = this.bundle.get(id);
        if (!item) return;
        if (action === 'remove') {
          this.bundle.delete(id);
          this.announce(this.messages.selectionRemoved.replace('[product]', item.title));
        } else {
          const quantity = item.quantity + (action === 'increase' ? item.increment : -item.increment);
          if (quantity < item.minimum || quantity > item.maximum) return;
          item.quantity = quantity;
        }
        this.updateSummary();
        const replacement = [...this.querySelectorAll('[data-kit-line-action]')].find(button => button.dataset.kitLineId === id && button.dataset.kitLineAction === action);
        if (replacement) replacement.focus({ preventScroll: true });
        else { const fallback = this.querySelector('[data-kit-line-action]') || item.card.querySelector('[data-kit-add]'); if (fallback) fallback.focus({ preventScroll: true }); }
      }
      announce(message) { this.querySelector('[data-kit-announcement]').textContent = message; }
      updateSummary() {
        const selected = [...this.bundle.values()];
        const list = this.querySelector('[data-kit-list]');
        list.replaceChildren();
        let subtotal = 0;
        let count = 0;
        selected.forEach(item => {
          subtotal += item.price * item.quantity;
          count += item.quantity;
          const row = document.createElement('li');
          if (item.image) { const image = document.createElement('img'); image.src = item.image; image.alt = ''; image.width = 49; image.height = 60; row.append(image); }
          else row.append(document.createElement('span'));
          const info = document.createElement('div'); info.className = 'iro-kit__line-info';
          const title = document.createElement('a'); title.textContent = item.title;
          const productUrl = new URL(item.card.dataset.url, document.baseURI); productUrl.searchParams.set('variant', item.id); title.href = productUrl.href;
          const option = document.createElement('small'); option.textContent = item.variant;
          const bottom = document.createElement('div'); bottom.className = 'iro-kit__line-bottom';
          const controls = document.createElement('div'); controls.className = 'iro-kit__line-controls';
          const makeButton = (action, text) => { const button = document.createElement('button'); button.type = 'button'; button.dataset.kitLineId = item.id; button.dataset.kitLineAction = action; button.textContent = text; button.setAttribute('aria-label', this.messages[action].replace('[product]', `${item.title}, ${item.variant}`)); return button; };
          const decrease = makeButton('decrease', '−'); decrease.disabled = item.quantity - item.increment < item.minimum;
          const output = document.createElement('output'); output.textContent = String(item.quantity);
          const increase = makeButton('increase', '+'); increase.disabled = item.quantity + item.increment > item.maximum;
          controls.append(decrease, output, increase);
          const price = document.createElement('strong'); price.textContent = this.money(item.price * item.quantity);
          bottom.append(controls, price);
          const remove = makeButton('remove', this.messages.remove.replace('[product]', '').trim()); remove.className = 'iro-kit__remove';
          info.append(title, option, bottom, remove); row.append(info); list.append(row);
        });
        this.cards.forEach(card => {
          const cardCount = selected.filter(item => item.card === card).reduce((total,item) => total + item.quantity, 0);
          card.classList.toggle('is-selected', cardCount > 0);
          const badge = card.querySelector('[data-kit-card-count]');
          badge.hidden = cardCount === 0; badge.textContent = this.messages.inBundle.replace('[count]', String(cardCount));
        });
        this.querySelector('[data-kit-empty]').hidden = selected.length > 0;
        this.querySelector('[data-kit-subtotal]').textContent = this.money(subtotal);
        this.querySelector('[data-kit-mobile-subtotal]').textContent = this.money(subtotal);
        this.querySelector('[data-kit-mobile-count]').textContent = count ? this.messages.itemCount.replace('[count]', String(count)) : this.messages.nothingSelected;
        this.querySelector('[data-kit-mobile]').hidden = selected.length === 0;
        this.querySelector('[data-kit-progress]').value = Math.min(count, this.minimum);
        this.querySelector('[data-kit-progress-count]').textContent = `${count} / ${this.minimum}`;
        this.querySelector('[data-kit-progress-label]').textContent = count >= this.minimum ? this.messages.progressReady : count === 0 ? this.messages.progressStart : this.messages.progressMore.replace('[count]', String(this.minimum - count));
        const needsQualification = selected.some(item => item.restricted);
        this.qualification.hidden = !needsQualification;
        this.qualification.disabled = !needsQualification;
        this.submitButton.disabled = count < this.minimum || this.busy || this.mustReview;
      }
      showFeedback(message, error = false) {
        this.feedback.textContent = message;
        this.feedback.classList.toggle('is-error', error);
        if (error) this.feedback.focus({ preventScroll: false });
      }
      async addKit(event) {
        event.preventDefault();
        if (this.busy || this.mustReview) return;
        const selected = [...this.bundle.values()];
        if (!selected.length) { this.showFeedback(this.messages.chooseFirst, true); return; }
        if (selected.reduce((count, item) => count + item.quantity, 0) < this.minimum) { this.showFeedback(this.messages.minimumRequired.replace('[count]', String(this.minimum)), true); return; }
        const referee = this.querySelector('[data-kit-referee]');
        const needsQualification = selected.some(item => item.restricted);
        referee.value = referee.value.trim();
        if (!this.form.reportValidity() || selected.some(item => !Number.isInteger(item.quantity) || item.quantity < item.minimum || item.quantity > item.maximum || (item.quantity - item.minimum) % item.increment !== 0)) { this.showFeedback(this.messages.checkFields, true); return; }
        const properties = needsQualification ? { [this.messages.refereeProperty]: referee.value, [this.messages.qualificationProperty]: this.messages.qualificationValue, _iro_qualified_acknowledged: 'true' } : {};
        const items = selected.map(item => ({ id: item.id, quantity: item.quantity, properties: item.restricted ? properties : {} }));
        this.busy = true;
        this.form.setAttribute('aria-busy', 'true');
        this.submitButton.disabled = true;
        this.submitButton.textContent = this.messages.adding;
        this.form.querySelectorAll('input, select, [data-kit-add], [data-kit-line-action]').forEach(control => { control.disabled = true; });
        this.showFeedback(this.messages.adding);
        const controller = new AbortController();
        const timeout = window.setTimeout(() => controller.abort(), 25000);
        try {
          const response = await fetch(this.dataset.addUrl, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items }), signal: controller.signal });
          let result;
          try { result = await response.json(); } catch { throw new Error(this.messages.uncertainResult); }
          if (!response.ok) { const detail = typeof result.description === 'string' ? result.description : ''; throw new Error(`${this.messages.cartError}${detail ? ` ${detail}` : ''}`); }
          if (!Array.isArray(result.items) || !items.every(requested => result.items.some(added => String(added.variant_id || added.id) === String(requested.id)))) throw new Error(this.messages.uncertainResult);
          this.showFeedback(this.messages.added);
          window.location.assign(this.dataset.cartUrl);
        } catch (error) {
          this.mustReview = true;
          const expected = error instanceof Error && (error.message.startsWith(this.messages.cartError) || error.message === this.messages.uncertainResult);
          this.showFeedback(expected ? error.message : this.messages.uncertainResult, true);
          this.submitButton.hidden = true;
          this.reviewLink.hidden = false;
          this.querySelector('[data-kit-summary-link]').textContent = this.messages.reviewCart;
        } finally { window.clearTimeout(timeout); this.form.removeAttribute('aria-busy'); this.busy = false; }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
